import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=7813eee1&"
import script from "./Notification.vue?vue&type=script&lang=babel&"
export * from "./Notification.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports